import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function AlarmesPage() {
  const nav = useNavigate();

  useEffect(() => {
    nav('/telesurveillance', { replace: true, state: { tab: 'alertes' } });
  }, [nav]);

  return null;
}
